"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_hook_form_1 = require("react-hook-form");
var react_i18next_1 = require("react-i18next");
var InputDirectionEnum_1 = require("../../../../../enums/InputDirectionEnum");
var CurrencyUtils_1 = require("../../../../../utils/CurrencyUtils");
var ExchangerUtils_1 = require("../../../../../utils/ExchangerUtils");
var CalculatorContextInterface_1 = require("../CalculatorContextInterface");
var CalculatorInputCostView = function (props) {
    var _a = (0, CalculatorContextInterface_1.useCalculatorContext)(), payment = _a.payment, appOrder = _a.appOrder, sale = _a.sale, setInputDirection = _a.setInputDirection, payAmount = _a.payAmount, setPayAmount = _a.setPayAmount, inputDirection = _a.inputDirection, defaultCurrency = _a.defaultCurrency, exchanger = _a.exchanger;
    var _b = (0, react_i18next_1.useTranslation)(), t = _b.t, i18n = _b.i18n;
    var _c = (0, react_hook_form_1.useFormContext)(), register = _c.register, errors = _c.formState.errors, setValue = _c.setValue;
    var _d = (0, react_1.useState)(0), commission = _d[0], setCommision = _d[1];
    var inputRef = (0, react_1.useRef)(null);
    function handleCostKeyChange(e) {
        var regex = /[0-9]|\./;
        if (!regex.test(e.key)) {
            e.preventDefault();
        }
    }
    function handleFocus() {
        setInputDirection(InputDirectionEnum_1.InputDirectionEnum.MONEY);
    }
    (0, react_1.useEffect)(function () {
        if (payment && payAmount && exchanger) {
            var value = payAmount + (payAmount * payment.commission) / 100;
            setCommision(value);
        }
        ;
    }, [payment, payAmount, exchanger]);
    (0, react_1.useEffect)(function () {
        if (inputDirection !== InputDirectionEnum_1.InputDirectionEnum.MONEY) {
            (payAmount)
                ? setValue('pay_amount', payAmount.toFixed(2))
                : setValue('pay_amount', undefined);
        }
    }, [payAmount]);
    (0, react_1.useEffect)(function () {
        if (sale) {
            setPayAmount(sale.total_price);
        }
    }, [sale]);
    (0, react_1.useEffect)(function () {
        if (payment && exchanger && sale) {
            var amount = sale.total_price / ExchangerUtils_1.ExchangerUtils.conver(exchanger, payment.currency_code);
            setPayAmount(amount);
        }
    }, [payment]);
    (0, react_1.useEffect)(function () {
        if (payment && sale) {
            setPayAmount(sale.total_price);
        }
    }, [payment]);
    (0, react_1.useEffect)(function () {
        if (appOrder) {
            setPayAmount(appOrder.amount);
            setValue('pay_amount', appOrder.amount);
            setInputDirection(InputDirectionEnum_1.InputDirectionEnum.MONEY);
        }
    }, [appOrder]);
    return (react_1.default.createElement("div", { className: "__wrap-item" },
        react_1.default.createElement("div", { className: "__wrap-top-item" }, errors.pay_amount
            ?
                react_1.default.createElement("div", { className: "__has-error" }, t("calculator.cost.error.emty"))
            :
                react_1.default.createElement(react_1.Fragment, null,
                    react_1.default.createElement("span", { className: "__top-notification" }, t("calculator.cost.input.caption")),
                    react_1.default.createElement("div", { className: "__top-notification-mobile-value mobile-only" },
                        react_1.default.createElement("span", { style: { marginRight: "4px" }, className: "" },
                            t("calculator.cost.input.bottom"),
                            " "),
                        react_1.default.createElement("span", { className: "__bottom-value" },
                            " ",
                            commission.toFixed(2),
                            " ",
                            CurrencyUtils_1.CurrencyUtils.symbol(payment ? payment.currency_code : defaultCurrency))))),
        react_1.default.createElement("div", { className: (0, classnames_1.default)('__input-icon-wrap', errors.pay_amount ? "__error" : "", payAmount ? "__succeess" : "") },
            react_1.default.createElement("span", { className: "icon" }, CurrencyUtils_1.CurrencyUtils.symbol(payment ? payment.currency_code : defaultCurrency)),
            react_1.default.createElement("input", __assign({ autoComplete: "off" }, register('pay_amount', {
                valueAsNumber: true,
                validate: {
                    positive: function (v) { return v > 0; },
                },
                onChange: function (e) { setPayAmount(parseFloat(e.target.value)); }
            }), { onFocus: handleFocus, onKeyPress: handleCostKeyChange, placeholder: t("calculator.cost.input.placeholder") }))),
        react_1.default.createElement("div", { className: "__wrap-bottom-item no-mobile", style: { marginTop: "8px" } },
            react_1.default.createElement("span", { className: "__bottom-notification" },
                t("calculator.cost.input.bottom"),
                " "),
            react_1.default.createElement("span", { className: "__bottom-value" },
                commission.toFixed(2),
                " ",
                CurrencyUtils_1.CurrencyUtils.symbol(payment ? payment.currency_code : defaultCurrency)))));
};
exports.default = CalculatorInputCostView;
